import React, { useMemo, useState } from "react";
import { Users } from "lucide-react";

import { useAppSelector } from "../../../app/hooks";
import { getPartiesInvolved } from "../../stakeholder/logic/stakeholderSlice";
import { InvestigationEntityCard } from "./InvestigationEntityCard";

import AddExistingStakeholderAsParty from "./AddExistingStakeholderAsParty";
import EntityPopoverRowWithBadge from "./EntityPopoverRow";

const PartyCard: React.FC = () => {
  const parties = useAppSelector(getPartiesInvolved);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  const partyItems = useMemo(
    () =>
      parties.map(
        (party) => `${party.name} - ${party.relatedAs}`
      ),
    [parties]
  );

  return (
    <>
      <InvestigationEntityCard
        title="Parties Involved"
        items={partyItems}
        onAdd={() => setIsAddModalOpen(true)}
        onManage={() => {}}
        disableManage
        popoverProps={{
          title: "Parties Involved",
          icon: <Users size={16} className="text-[#94A3B8]" />,
          items: parties.map((party, index) => ({
            content: (
              <EntityPopoverRowWithBadge
                title={party.name}
                badge={party.relatedAs}
                secondaryText={party.loanReferences}
                showDivider={index > 0}
              />
            ),
          })),
        }}
        emptyState={{
          icon: <Users size={18} className="text-[#94A3B8]" />,
          message: "No parties added",
        }}
      />

      {isAddModalOpen && (
        <AddExistingStakeholderAsParty
          onClose={() => setIsAddModalOpen(false)}
        />
      )}
    </>
  );
};

export default PartyCard;